import { render, staticRenderFns } from "./Algeria.vue?vue&type=template&id=75fbf078&"
import script from "./Algeria.vue?vue&type=script&lang=js&"
export * from "./Algeria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports